// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar_button[data-v-438da721]{align-items:center;background-color:var(--v-users-darken1);color:#fff;display:flex;font-size:20px;font-weight:600;height:var(--cosmic-top-nav-bar-height);justify-content:center;text-transform:uppercase;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:var(--cosmic-top-nav-bar-height);&[data-v-438da721]:focus-visible,&[data-v-438da721]:hover{background-color:var(--cosmic-gray-lighten-3);color:var(--v-user_groups-darken2)}}", ""]);
// Exports
module.exports = exports;
